import React, { createContext, useState, useContext } from 'react';

interface IProps {
  message: string;
  open: boolean;
  onClose?: () => void;
  autoHideDuration?: number;
  isShowBtn?: boolean;
  btnContent?: string;
  btnOnClick?: any;
  isShowCloseBtn?: boolean;
}

const SnackbarContext = createContext(null);

export const SnackbarProvider = ({ children }) => {
  const [defaultSnackbarProps] = useState<IProps>({
    open: false,
    message: '',
    autoHideDuration: 3000,
    isShowBtn: false,
    btnContent: '',
    btnOnClick: null,
    isShowCloseBtn: true,
    onClose: () => setSnackbarProps((prev) => ({ ...prev, open: false }))
  });

  const [snackbarProps, setSnackbarProps] = useState<IProps>({
    open: false,
    message: '',
    autoHideDuration: 3000,
    isShowBtn: false,
    btnContent: '',
    btnOnClick: null,
    isShowCloseBtn: true,
    onClose: () => setSnackbarProps((prev) => ({ ...prev, open: false }))
  });

  const showSnackbar = (props: IProps) => {
    setSnackbarProps({ ...defaultSnackbarProps, ...props, open: true });
  };

  return (
    <SnackbarContext.Provider value={{ snackbarProps, showSnackbar }}>
      {children}
    </SnackbarContext.Provider>
  );
};

export const useSnackbar = () => {
  return useContext(SnackbarContext);
};
